// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
    LoadRecommendedProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import log from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/Log";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { CustomProductInfoListParameter } from "@west/App/Handlers/ProductInfoList/LoadProductInfoList";

export const XngLoadProducts: typeof LoadProducts = ({
    dispatch,
    getProductCollectionParameter,
    extraProductCollectionParameter,
    additionalSort,
    parameter: { carouselId, carouselType, numberOfProductsToDisplay, isProductDetailsPage, productId, isShellEdit },
}) => {
    if (!getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = extraProductCollectionParameter
        ? {
              getProductCollectionParameter: extraProductCollectionParameter,
              numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP = carouselType === "recentlyViewed" && isProductDetailsPage;

    getProductCollectionParameter.expand
        ? getProductCollectionParameter.expand.push("images", "badges", "properties", "variantTraits")
        : (getProductCollectionParameter.expand = ["images", "badges", "properties", "variantTraits"]);

    dispatch(
        loadProductInfoList({
            id: carouselId,
            getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit,
            additionalSort,
            carouselType,
        } as CustomProductInfoListParameter),
    );
};

export const XngLoadRecommendedProducts: typeof LoadRecommendedProducts = props => {
    const {
        getState,
        dispatch,
        parameter: { carouselType, widgetPosition, numberOfProductsToDisplay },
    } = props;

    if (carouselType !== "recommendedProducts") {
        return;
    }

    const { widgets } = getState().components.productRecommendations;
    if (!widgets) {
        return;
    }

    if ((widgetPosition || 1) > widgets.length) {
        dispatch(log({ message: "Widget position greater than products recommendations response", type: "error" }));
        return;
    }

    const widget = widgets[widgetPosition ? widgetPosition - 1 : 0];

    dispatch(log({ message: "Recommended Products - Selected: ", data: widget }));

    if (!widget.recs || widget.recs.length === 0) {
        return;
    }

    const productErpNumbers = widget.recs.slice(0, numberOfProductsToDisplay).map(o => o.refCode);
    props.getProductCollectionParameter = { productNumbers: productErpNumbers };
    //    fix for recommendation products carousel
    props.additionalSort = (products: ProductModel[]) =>
        productErpNumbers
            .map(o => products.find(p => p.productNumber === o || p.properties.styleParentErpNumber === o))
            .filter(o => !!o) as ProductModel[];
};

replaceInChain(chain, LoadRecommendedProducts, XngLoadRecommendedProducts);
replaceInChain(chain, LoadProducts, XngLoadProducts);
